import { Rectangle } from "@stage/math";
/**
 * 是否重叠
 * 重心距离 投影x,y长度小于 矩形width height
 * @param rect
 * @param rect2
 */
Rectangle.overlap = function overlap(rect, rect2) {
  return Math.abs(rect.x + rect.width / 2 - (rect2.x + rect2.width / 2)) < (rect.width + rect2.width) / 2 && Math.abs(rect.y + rect.height / 2 - (rect2.y + rect2.height / 2)) < (rect.height + rect2.height) / 2;
};

/**
 * 缩放比率
 * @param rect
 * @param radio
 */
Rectangle.radio = function radio(rect, radio) {
  var _rect = rect,
    x = _rect.x,
    y = _rect.y,
    width = _rect.width,
    height = _rect.height;
  return {
    x: x * radio,
    y: y * radio,
    width: width * radio,
    height: height * radio
  };
};
Rectangle.translate = function translate(rect, translate) {
  return {
    x: rect.x + translate.x,
    y: rect.y + translate.y,
    width: rect.width,
    height: rect.height
  };
};
export function byTransformOrigin(box) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    xOffset: 'left',
    yOffset: 'top'
  };
  var originX, originY;
  switch (origin.xOffset) {
    case 'left':
      originX = 0;
      break;
    case 'center':
      originX = box.width / 2;
      break;
    case 'right':
      originX = box.width;
      break;
    default:
      originX = origin.xOffset;
      break;
  }
  switch (origin.yOffset) {
    case 'top':
      originY = 0;
      break;
    case 'center':
      originY = box.height / 2;
      break;
    case 'bottom':
      originY = box.height;
      break;
    default:
      originY = origin.yOffset;
      break;
  }
  return {
    x: originX,
    y: originY
  };
}
Rectangle.resize = function resize(rect, transform) {
  var _transform$x = transform.x,
    x = _transform$x === void 0 ? 0 : _transform$x,
    _transform$y = transform.y,
    y = _transform$y === void 0 ? 0 : _transform$y,
    _origin = transform.origin;
  var delta = {
    x: x,
    y: y
  };
  var origin = byTransformOrigin(rect, _origin);
  var translate = {
    x: -delta.x * (origin.x / rect.width),
    y: -delta.y * (origin.y / rect.height)
  };
  return {
    x: rect.x + translate.x,
    y: rect.y + translate.y,
    width: rect.width + delta.x,
    height: rect.height + delta.y
  };
};
Rectangle.scale = function scale(rect, transform) {
  var origin = transform.origin,
    sx = transform.sx,
    sy = transform.sy;
  return Rectangle.resize(rect, {
    origin: origin,
    x: rect.width * (sx - 1),
    y: rect.height * (sy - 1)
  });
};